import { TabValue } from '@growdash/growintel/constants/Tabs';
import Cookies from 'js-cookie';
import { useEffect, useMemo, useState } from 'react';
import useGrowintUser from './useGrowintUser';

export function useOnboarding(key: TabValue) {
  const user = useGrowintUser();
  const clientId = user?.clientId ?? '-';

  const cookieKey = useMemo(() => `onboarding-${key}-${clientId}`, [clientId]);

  const [isOnboarded, setIsOnboarded] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      return Cookies.get(cookieKey) === 'true';
    }
    return false;
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const cookieValue = Cookies.get(cookieKey);
      setIsOnboarded(cookieValue === 'true');
    }
  }, [key]);

  const markAsOnboarded = () => {
    if (typeof window !== 'undefined') {
      Cookies.set(cookieKey, 'true', { expires: 365, path: '/' });
      setIsOnboarded(true);
    }
  };

  const resetOnboarding = () => {
    if (typeof window !== 'undefined') {
      Cookies.remove(cookieKey, { path: '/' });
      setIsOnboarded(false);
    }
  };

  return {
    isOnboarded,
    markAsOnboarded,
    resetOnboarding,
  };
}
